import { useListContext, useResourceContext, useTranslate } from 'react-admin';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Box, Select, MenuItem, FormControl, InputLabel, useTheme, useMediaQuery } from '@mui/material';
import { analyticsStyles } from '@/themes/commonStyles/analytics.js';
import { periods } from '@/constants/Filters.jsx';
import { getCustomPeriodDefaults } from '@/components/analytics/PeriodFilters.jsx';

const StyledPeriodForm = styled(Box)(() => ({
    ...analyticsStyles.periodInput,
}));

export const PeriodFilterInput = ({ defaultPeriod = 30, label }) => {
    const translate = useTranslate();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const { setFilters, filterValues } = useListContext();
    const resource = useResourceContext();

    const defaultLabel = label || translate('resources.collectionPoint.labels.period');
    const periodLabel = isMobile ? label || translate('resources.transaction.labels.period') : defaultLabel;

    const handlePeriodChange = event => {
        const newPeriod = event.target.value;
        const newFilterValues = { ...filterValues, period: newPeriod };

        if (newPeriod === 'custom') {
            Object.assign(newFilterValues, getCustomPeriodDefaults(resource));
        } else {
            delete newFilterValues.periodStart_gte;
            delete newFilterValues.periodEnd_lte;
        }

        setFilters(newFilterValues);
    };
    const currentPeriod = filterValues?.period || defaultPeriod;

    return (
        <StyledPeriodForm className='period-form'>
            <FormControl className='period-select'>
                <InputLabel>{periodLabel}</InputLabel>
                <Select value={currentPeriod} label={periodLabel} onChange={handlePeriodChange}>
                    {periods.map(period => (
                        <MenuItem key={period.id} value={period.id}>
                            {translate(period.name)}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </StyledPeriodForm>
    );
};

PeriodFilterInput.propTypes = {
    defaultPeriod: PropTypes.number,
    label: PropTypes.string,
};
